import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { toast } from 'react-toastify';
import LoadingDots from './LoadingDots';
import Loader from './Loader';

const timeOptions = [
  "FLEXIBLE",
  "08:00 AM",
  "09:00 AM",
  "10:00 AM",
  "11:00 AM",
  "12:00 AM",
  "01:00 PM",
  "02:00 PM",
];

const ListingStep16 = ({ formData, handleChange, prevStep, onRegisterSave }) => {
  const { listingId } = formData;
  const [listingData, setListingData] = useState([]);
  const [checkinTimeStart, setCheckinTimeStart] = useState(null);
  const [checkinTimeEnd, setCheckinTimeEnd] = useState(null);
  const [checkoutTime, setCheckoutTime] = useState(null);
  const [question, setQuestion] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [nextLoading, setNextLoading] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchListingData = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      let formData = new FormData();
      formData.append('token', hostData.host_access_token);
      formData.append('listing_id', listingId);
  
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          url: `${params.baseURL}${params.endpoints.getListingData}`,
          data: formData,
        });
  
        if (response.data.status === 'ok') {
          const listingData = response.data.updated_property_item;
          const { appr_list, resrv_list, offers, place_options_list } = listingData;
          setListingData(response.data.updated_property_item);
          setQuestion(response.data.updated_property_item.questions);
          try {
            setCheckinTimeStart(listingData.checkin_time_start);
            setCheckinTimeEnd(listingData.checkin_time_ends);
            setCheckoutTime(listingData.checkout_time);
            setLoading(false);
        } catch (error) {
            toast.error('Error parsing listing data: ' + error.message);
            console.error('Parsing error:', error);
            setLoading(false);
          }
        } else {
          toast.error('An error occurred while fetching data.');
          setLoading(false);
        }
      } catch (err) {
        console.log(err.message);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };
  
    fetchListingData();
  }, [listingId]); 

  
    const saveListing = async () => {
      const hostData = getItemFromLocalStorage('hostProfile');
      const listing_id = listingId;
      const ts = Date.now();
    
      const updatedPropertyItem = {
        checkin_time_start: checkinTimeStart,
        checkin_time_ends: checkinTimeEnd,
        checkout_time: checkoutTime,
      };

      const mergedData = { ...listingData, ...updatedPropertyItem };
    
      let catData = new FormData();
      catData.append('token', hostData.host_access_token);
      catData.append('listing_id', listing_id);
      catData.append('data', JSON.stringify(mergedData)); 
      catData.append('ts', ts); 

      setNextLoading(true);
    
      try {
        const response = await axios({
          method: 'post',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          url: `${params.baseURL}${params.endpoints.updateListing}`,
          data: catData,
        });
    
        if (response.data.status === 'done') {
          return true;
        } else {
          toast.error('Failed to save data');
          return false;
        }
      } catch (err) {
        toast.error('An error occurred while saving the listing');
        return false;
      }
    };

   

  const getFilteredEndTimes = () => {
    if (!checkinTimeStart || checkinTimeStart === "FLEXIBLE") return timeOptions;

    const startIndex = timeOptions.indexOf(checkinTimeStart);
    return timeOptions.slice(startIndex + 1);
  };

  const faqs = [
    {
        question: "What is Lorem Ipsum?",
        answer: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
    },
    {
        question: "Where does it come from?",
        answer: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old."
    },
  ];
  
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (loading) {
    return (
      <Loader />
    );
  }

  return (
    <div className="fade-in">
      <button id='host-listing-trigger-16' style={{ display: 'none' }} onClick={() => {
        if (onRegisterSave) {
          onRegisterSave(saveListing);
        }
      }}>Done</button>
      <div className='row'>
        {/*<div className='col-md-4 listing-img-box'>
          <div className='lsib'>
            <img src={'/assets/img/listing/listing_side_img.gif'} alt="Listing Image" className="listing-image" />
            {question && (
              <div className='lsqa-btn'>
                <StarButton text="Guide" link={question.find((q) => q.id === 16)?.link || '#'} />
              </div>
            )}
          </div>
        </div>*/}

        <div className='col-md-7'>

          <div className='ws-cl-header'>
            <div>
              <h4 className='ws-title'>Set Your Property’s Check-In and Check-Out Time!</h4>
              <p className='ws-desc'>
                <span className='d-block mb-1'>Wire Stay allows you to set your property’s check-in and check-out times, but we suggest aligning with standard hotel times, such as 11 AM to 11 AM, for guest convenience.</span>
                <span>If your property remains unbooked, enable the “Last-Minute Discount” option below. This will push your property to the top and notify potential guests with offers and discounts.</span>
              </p>
            </div>
          </div>

          <div className='st1-desc-box'>
            <div className='row'>

                <div className='col-md-12 p-0'>
                    <p>Check-in window</p>
                </div>
                
                <div className="col-md-6 mb-3 ps-0">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="check-in-start"
                      name="check_in"
                      value={checkinTimeStart}
                      onChange={(e) => {
                        setCheckinTimeStart(e.target.value);
                        setCheckinTimeEnd("");
                      }}
                    >
                      <option value="">Select</option>
                      {timeOptions.map((time) => (
                        <option key={time} value={time}>{time}</option>
                      ))}
                    </select>
                    <label htmlFor="check-in-start">Start time</label>
                  </div>
                </div>

                <div className="col-md-6 mb-3 pe-0">
                  <div className="form-floating">
                    <select
                      className="form-select"
                      id="check-in-end"
                      name="check_in"
                      value={checkinTimeEnd}
                      onChange={(e) => setCheckinTimeEnd(e.target.value)}
                      disabled={checkinTimeStart === "FLEXIBLE"}
                    >
                      <option value="">Select</option>
                      {getFilteredEndTimes().map((time) => (
                        <option key={time} value={time}>{time}</option>
                      ))}
                    </select>
                    <label htmlFor="check-in-end">End time</label>
                  </div>
                </div>

                <div className="col-md-12 mb-3 p-0">
                    <p>Checkout time</p>
                    <div className="form-floating">
                        <select className="form-select" id="check-out" name="check_out"
                            value={checkoutTime}
                            onChange={(e) => setCheckoutTime(e.target.value)}
                        >
                          <option></option>
                          <option value="12:00 AM">12:00 AM</option>
                          <option value="01:00 AM">01:00 AM</option>
                          <option value="02:00 AM">02:00 AM</option>
                          <option value="03:00 AM">03:00 AM</option>
                          <option value="04:00 AM">04:00 AM</option>
                          <option value="05:00 AM">05:00 AM</option>
                          <option value="06:00 AM">06:00 AM</option>
                          <option value="07:00 AM">07:00 AM</option>
                        </select>    
                        <label htmlFor="check-out">Select time</label>
                    </div>
                </div>

                <div className="col-md-12 mb-3 p-0"> 
                  <div class="custom-checkbox-container">
                    <input class="custom-checkbox-input" id="modernCheckbox" type="checkbox" />
                    <label class="custom-checkbox-label" for="modernCheckbox">
                      <span class="custom-checkbox-text">Enable Last-Minute Discount</span>
                    </label>
                  </div>
                </div>

            </div>
          </div>

        </div>
        <div className='col-md-1'></div>
        <div className='col-md-4 p-0'>
          <div className='bfhsd'>
              <div className='blog-box'>
                  <div class="blog">
                      <div class="blog-image">
                          <img src={'https://app.wirestay.com/ws/uploads/blog/1736870810_pi.jpg'} className='img-fluid' alt="" />
                          <div class="date">May 08, 2025</div>
                      </div>
                      <div class="blog-content">
                          <h2>What is Lorem Ipsum?</h2>
                          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris vel metus vel est fermentum consectetur.</p>
                          <a href="#">Read More</a>
                      </div>
                  </div>
              </div>
              <div className="faq-sticky">
                  {faqs.map((faq, index) => (
                  <div key={index} className='faqs-list-section'>
                      <div
                      onClick={() => toggleAccordion(index)} className='faqs-qustn-box'
                      style={{
                          backgroundColor: activeIndex === index ? "#f7f7f7" : "#ffffff",
                      }}
                      >
                      {faq.question}
                      <i
                          className={`fas ${
                          activeIndex === index ? "fa-chevron-up" : "fa-chevron-down"
                          }`}
                          style={{
                          transition: "transform 0.3s ease",
                          }}
                      ></i>
                      </div>
                      {activeIndex === index && (
                      <div className='faqs-ans-box'>
                          {faq.answer}
                      </div>
                      )}
                  </div>
                  ))}
              </div>
          </div>
        </div>

      </div>
    </div>
  );
};

export default ListingStep16;
